module.exports = __webpack_public_path__ + "img/935786950.b8d6dea3.jpg";